import axios from 'axios'
import constants from '../constants'
import { getAuthorizationHeader } from './_token'
import store from '../store'
import { LOGOUT } from '../reducers/user'
import { joinPaths } from 'utils/helpers'

export const apiURL = constants.API_URL
export const apiVersion = constants.API_VERSION
export const crURL = constants.CR_URL
export const appTimeout = parseInt(constants.APP_TIMEOUT, 10)

const baseURL = joinPaths(apiURL, apiVersion)
export const api = axios.create({
    baseURL,
    timeout: appTimeout,
    transformRequest: [function (data, headers) {
        const authorization = getAuthorizationHeader()
        const partnerId = store.getState()?.user?.partnerId

        if (authorization) {
            headers['Authorization'] = authorization
        }

        if(partnerId) {
            headers['X-Preferred-Partner-Id'] = partnerId
        }
        return JSON.stringify(data)
    }],
    headers: {
        'Content-Type': 'application/json',
    }
})

api.interceptors.response.use(null, (error) => {
    if (error && error.response && error.response.status === 401) {
        store.dispatch({ type: LOGOUT })
    }
    return Promise.reject(error)
})

export const cr_api = axios.create({
    baseURL: crURL,
    timeout: appTimeout,
    crossdomain: true,
    transformRequest: [function (data, headers) {
        const authorization = getAuthorizationHeader()
        const partnerId = store.getState()?.user?.partnerId

        if (authorization) {
            headers['Authorization'] = authorization
        }
        if(partnerId) {
            headers['X-Preferred-Partner-Id'] = partnerId
        }
        return JSON.stringify(data)
    }],
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
    }
})
